import React from 'react';
import * as I from '../components/ToolIcons';
import type { IconProps } from '../components/ToolIcons';

export interface Tool {
    name: string;
    icon: React.FC<IconProps>;
    tags: string[];
}

export const toolsData: { [key: string]: Tool[] } = {
  Clinical: [
    { 
        name: 'Emergency Guide', 
        icon: I.EmergencyGuideIcon,
        tags: ['acls', 'cpr', 'code blue', 'cardiac arrest', 'shock', 'epinephrine', 'atropine', 'drips', 'pressors']
    },
    { 
        name: 'Analyze Rx', 
        icon: I.AnalyzeRxIcon,
        tags: ['safety', 'check', 'verification', 'dur', 'error', 'prescription', 'review', 'audit']
    },
    { 
        name: 'Antibiotics', 
        icon: I.AntibioticsIcon,
        tags: ['infectious disease', 'id', 'bacteria', 'spectrum', 'empiric', 'pneumonia', 'uti', 'sepsis', 'vanc', 'penicillin']
    },
    { 
        name: 'Anticholinergic Burden', 
        icon: I.AnticholinergicBurdenIcon,
        tags: ['acb', 'geriatrics', 'beers', 'confusion', 'falls', 'dry mouth', 'benadryl', 'dementia', 'cognitive']
    },
    { 
        name: 'Anticoag Bridging', 
        icon: I.AnticoagBridgingIcon,
        tags: ['warfarin', 'lovenox', 'enoxaparin', 'surgery', 'perioperative', 'bleed', 'clot', 'inr', 'heparin']
    },
    { 
        name: 'Clinical Criteria', 
        icon: I.ClinicalCriteriaIcon,
        tags: ['calc', 'score', 'chadsvasc', 'wells', 'curb65', 'child pugh', 'meld', 'risk', 'assessment']
    },
    { 
        name: 'Clinical Trials', 
        icon: I.ClinicalTrialsIcon,
        tags: ['studies', 'evidence', 'literature', 'pubmed', 'research', 'new drugs', 'nct']
    },
    { 
        name: 'Dietary Guide', 
        icon: I.DietaryGuideIcon,
        tags: ['food', 'nutrition', 'interaction', 'grapefruit', 'vitamin k', 'tyramine', 'maoi', 'meal']
    },
    { 
        name: 'Dose Adjust', 
        icon: I.DoseAdjustIcon,
        tags: ['renal', 'kidney', 'hepatic', 'liver', 'crcl', 'dialysis', 'impairment', 'adjustment']
    },
    { 
        name: 'Drug Tapering', 
        icon: I.DrugTaperingIcon,
        tags: ['wean', 'stop', 'discontinue', 'schedule', 'opioid', 'benzo', 'steroid', 'prednisone', 'withdrawal']
    },
    { 
        name: 'Fitness Guide', 
        icon: I.FitnessGuideIcon,
        tags: ['sports', 'supplements', 'creatine', 'protein', 'doping', 'performance', 'gym', 'workout']
    },
    { 
        name: 'Formulary Analyzer', 
        icon: I.FormularyAnalyzerIcon,
        tags: ['insurance', 'coverage', 'pa', 'prior auth', 'tier', 'copay', 'plan', 'medicare', 'medicaid']
    },
    { 
        name: 'Geriatric Guide', 
        icon: I.GeriatricGuideIcon,
        tags: ['elderly', 'seniors', 'beers', 'pim', 'falls', 'dementia', 'safety', 'age']
    },
    { 
        name: 'Guidelines', 
        icon: I.GuidelinesIcon,
        tags: ['idsa', 'ada', 'aha', 'acc', 'chest', 'gold', 'gina', 'kdigo', 'standards', 'protocol']
    },
    { 
        name: 'HIV Info', 
        icon: I.HIVInfoIcon,
        tags: ['aids', 'arv', 'antiretroviral', 'prep', 'pep', 'biktarvy', 'cd4', 'viral load']
    },
    { 
        name: 'INR Info', 
        icon: I.INRInfoIcon,
        tags: ['warfarin', 'coumadin', 'pt', 'clot', 'bleed', 'vitamin k', 'reversal', 'anticoagulant']
    },
    { 
        name: 'Insulin Tool', 
        icon: I.InsulinToolIcon,
        tags: ['diabetes', 'sugar', 'glucose', 'lantus', 'humalog', 'sliding scale', 'conversion', 'units']
    },
    { 
        name: 'Interactions', 
        icon: I.InteractionsIcon,
        tags: ['ddi', 'conflict', 'contraindication', 'cyp', 'metabolism', 'checker', 'safety']
    },
    { 
        name: 'IV Compatibility', 
        icon: I.IVCompatibilityIcon,
        tags: ['y-site', 'trissel', 'mixing', 'diluent', 'ns', 'd5w', 'precipitate', 'line', 'injection']
    },
    { 
        name: 'Missed Dose', 
        icon: I.MissedDoseIcon,
        tags: ['forgot', 'skip', 'late', 'catch up', 'guidance', 'adherence']
    },
    { 
        name: 'MME Calculator', 
        icon: I.MMECalculatorIcon,
        tags: ['opioid', 'morphine', 'equivalence', 'pain', 'narcotic', 'oxycodone', 'hydrocodone', 'conversion']
    },
    { 
        name: 'MTM/CMR', 
        icon: I.MTMCMRToolIcon,
        tags: ['medication therapy management', 'review', 'comprehensive', 'soap', 'billing', 'consult', 'map']
    },
    { 
        name: 'Patient Counseling', 
        icon: I.PatientCounselingIcon,
        tags: ['education', 'points', 'teach', 'side effects', 'instructions', 'consultation', 'script']
    },
    { 
        name: 'Pediatric Guide', 
        icon: I.PediatricGuideIcon,
        tags: ['kids', 'children', 'weight', 'dosing', 'liquid', 'suspension', 'tylenol', 'motrin', 'antibiotic']
    },
    { 
        name: 'PGx Guide', 
        icon: I.PGxGuideIcon,
        tags: ['pharmacogenomics', 'genetics', 'dna', 'cyp2c19', 'cyp2d6', 'clopidogrel', 'metabolizer', 'cpic']
    },
    { 
        name: 'Pharmacokinetics', 
        icon: I.PharmacokineticsIcon,
        tags: ['pk', 'half life', 'clearance', 'vd', 'steady state', 'levels', 'trough', 'peak', 'monitoring']
    },
    { 
        name: 'Pregnancy & Lactation', 
        icon: I.PregnancyLactationIcon,
        tags: ['breastfeeding', 'nursing', 'baby', 'fetus', 'teratogenic', 'safety', 'risk', 'category', 'briggs']
    },
    { 
        name: 'Therapeutic Interchange', 
        icon: I.TherapeuticInterchangeIcon,
        tags: ['switch', 'convert', 'equivalent', 'formulary', 'statin', 'ace', 'arb', 'ppi', 'substitution']
    },
    { 
        name: 'Vaccine Tool', 
        icon: I.VaccineToolIcon,
        tags: ['immunization', 'schedule', 'cdc', 'acip', 'flu', 'pneumonia', 'shingles', 'shot', 'travel']
    },
  ],
  Retail: [
    { 
        name: 'Compounding Calculator', 
        icon: I.CompoundingCalculatorIcon,
        tags: ['mix', 'recipe', 'dilution', 'alligation', 'percentage', 'concentration', 'magic mouthwash']
    },
    { 
        name: 'CS Reference', 
        icon: I.CSReferenceIcon,
        tags: ['controlled', 'substance', 'schedule', 'c2', 'narcotic', 'law', 'dea', 'validity']
    },
    { 
        name: 'Days Supply', 
        icon: I.DaysSupplyIcon,
        tags: ['drops', 'insulin', 'inhaler', 'cream', 'ointment', 'duration', 'billing', 'insurance']
    },
    { 
        name: 'Drug Price Finder', 
        icon: I.DrugPriceFinderIcon,
        tags: ['cost', 'cash', 'discount', 'coupon', 'goodrx', 'cheapest', 'generic']
    },
    { 
        name: 'Federal Laws', 
        icon: I.FederalLawIcon,
        tags: ['regulations', 'hipaa', 'obra', 'cmea', 'fda', 'legal', 'pharmacy law']
    },
    { 
        name: 'OTC Finder', 
        icon: I.OTCFinderIcon,
        tags: ['counter', 'non-prescription', 'cough', 'cold', 'allergy', 'pain', 'stomach', 'brand', 'generic']
    },
    { 
        name: 'PA Assistant', 
        icon: I.PAAssistantIcon,
        tags: ['prior auth', 'insurance', 'appeal', 'letter', 'justification', 'coverage', 'denial']
    },
    { 
        name: 'Pill Identifier', 
        icon: I.PillIdentifierIcon,
        tags: ['shape', 'color', 'imprint', 'marking', 'unknown', 'tablet', 'capsule', 'image']
    },
    { 
        name: 'Sig Codes', 
        icon: I.SigCodesIcon,
        tags: ['abbreviation', 'latin', 'translate', 'directions', 'frequency', 'route', 'script']
    },
    { 
        name: 'State Law Reference', 
        icon: I.StateLawReferenceIcon,
        tags: ['bop', 'board', 'regulations', 'counseling', 'ratios', 'tech', 'legal']
    },
  ],
  Reference: [
    { 
        name: 'Antidotes', 
        icon: I.AntidotesIcon,
        tags: ['poison', 'toxin', 'overdose', 'reversal', 'rescue', 'emergency', 'toxicology', 'naloxone']
    },
    { 
        name: 'Biostats', 
        icon: I.BiostatsIcon,
        tags: ['statistics', 'p-value', 'nnt', 'sensitivity', 'specificity', 'odds ratio', 'study', 'math']
    },
    { 
        name: 'Calculators', 
        icon: I.CalculatorsIcon,
        tags: ['math', 'formula', 'bsa', 'bmi', 'ibw', 'crcl', 'qtc', 'calcium', 'anc']
    },
    { 
        name: 'Cannabinoids', 
        icon: I.CannabinoidsIcon,
        tags: ['marijuana', 'thc', 'cbd', 'dispensary', 'terpenes', 'receptors', 'interactions']
    },
    { 
        name: 'CE Tracker', 
        icon: I.CTTrackerIcon,
        tags: ['continuing education', 'credits', 'license', 'renewal', 'hours', 'log']
    },
    { 
        name: 'Chemo Man', 
        icon: I.ChemoManIcon,
        tags: ['oncology', 'cancer', 'toxicity', 'side effects', 'cisplatin', 'doxorubicin', 'vincristine']
    },
    { 
        name: 'Compounding Formulas', 
        icon: I.CompoundingFormulasIcon,
        tags: ['recipes', 'preparation', 'magic mouthwash', 'suspension', 'cream', 'mix', 'bud', 'stability']
    },
    { 
        name: 'Conversions', 
        icon: I.ConversionsIcon,
        tags: ['steroid', 'opioid', 'temperature', 'weight', 'volume', 'unit', 'equivalence']
    },
    { 
        name: 'Drug Shortage Tracker', 
        icon: I.DrugShortageTrackerIcon,
        tags: ['unavailable', 'backorder', 'supply', 'fda', 'ashp', 'alternative', 'status']
    },
    { 
        name: 'Forms Finder', 
        icon: I.FormsFinderIcon,
        tags: ['pdf', 'dea 222', 'dea 106', 'application', 'license', 'document', 'download']
    },
    { 
        name: 'Lab Charts', 
        icon: I.LabChartsIcon,
        tags: ['blood', 'values', 'normal range', 'bmp', 'cmp', 'cbc', 'lft', 'inr', 'levels']
    },
    { 
        name: 'Mnemonics', 
        icon: I.MnemonicsIcon,
        tags: ['memory', 'study', 'trick', 'acronym', 'learning', 'help', 'student']
    },
    { 
        name: 'Vitamins', 
        icon: I.VitaminsIcon,
        tags: ['supplement', 'deficiency', 'nutrition', 'mineral', 'herbal', 'otc']
    },
  ],
};


const allToolsList: Tool[] = Object.values(toolsData).flat();

export const allToolsMap = new Map<string, Tool>(
    allToolsList.map(tool => [tool.name, tool])
);